import { find, map } from 'lodash'
import { ContactSiteData } from '../apis/contactSite.api'

export default {
  find (contactSites: ContactSiteData[], id: number) {
    return find(contactSites, { id })
  },

  selectOptions (contactSites: ContactSiteData[]) {
    return map(contactSites, contactSite => {
      const { name, id } = contactSite
      return { name, value: String(id) }
    })
  }
}
